<template>
    <div class="calendarlist">
        <h1>Calendar List</h1>
        <div class="calendar" v-for="(c, ind) in calendars" :key="ind">
            <input type="checkbox" :checked="selectedCalendars[c.id]" @click="toggleCalendar(c.id)">
            <span :style="{color: c.colour}"> {{c.dispName}}</span>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'calendarList',
  i18nOptions: { keyPrefix: 'calendars.list' },
  data: function() {
    return {
      calendarList: []
    };
  },
  mounted() {
    axios.get('/rest/user/calendars')
      .then(d => {
        this.calendarList = d.data;
        console.log('got calendars', d.data);
        this.$store.commit('setCalendars', { calendars: this.calendarList });
      })
      .catch(e => {
        this.$dialog.alert(this.$t('error', { error: e }));
      });
  },
  methods: {
    toggleCalendar(id) {
      this.$store.dispatch('toggleCalendar', { calendarId: id });
    }
  },
  computed: {
    selectedCalendars() {
      return this.$store.getters.selectedCalendars;
    },
    calendars() {
      const thisUser = this.$store.state.username;
      return this.calendarList.map(c => {
        let cal = Object.assign({}, c);
        if (c.owner !== thisUser) {
          cal.dispName = this.$t('sharedCalendar', { owner: c.owner, name: c.name });
        } else {
          cal.dispName = this.$t('calendar', { owner: c.owner, name: c.name });
        }
        return cal;
      }).sort((a, b) => {
        if ((a.owner === thisUser) && (b.owner !== thisUser)) {
          return -1;
        } else if ((a.owner !== this.User) && (b.owner === thisUser)) {
          return 1;
        }
        return a.dispName.localeCompare(b.dispName);
      });
    }
  }
};
</script>

<style scoped lang="scss">
    .calendar {
        cursor: pointer;
    }

</style>
